import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filter', standalone: true })
export class FilterPipe<T> implements PipeTransform {
  transform(value: Array<T>, callback: (item: T) => boolean): Array<T> {
    return value.filter(callback);
  }
}
